<template>
  <v-dialog
    :value="show"
    @input="$store.dispatch('$_notifications/hideAlert')"
    max-width="450"
  >
    <v-card class="pb-4" :class="classType">
      <v-card-text class="d-flex align-center px-2 pt-5 pb-2">
        <v-icon left size="60">mdi-alert-circle-outline</v-icon>
        <div class="mt-1">
          <h1 v-if="alert.title">{{ alert.title }}</h1>
          <p>{{ alert.message }}</p>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          rounded
          class="px-12"
          @click="$store.dispatch('$_notifications/hideAlert')"
        >
          {{ alert.cancelTitle }}
        </v-btn>
        <v-btn
          v-for="action in alert.actions"
          class="ml-4 px-12"
          dark
          rounded
          :color="color"
          :key="action.title"
          :loading="action.loading"
          @click="exec(action)"
          >{{ action.title }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../modules/notifications/_store";

export default {
  data() {
    return {
      loading: false
    };
  },
  created() {
    const STORE_KEY = "$_notifications";
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  computed: {
    ...mapGetters({
      alert: "$_notifications/alert",
      show: "$_notifications/show"
    }),
    classType() {
      return this.alert.type ? this.alert.type : "alert";
    },
    color() {
      switch (this.classType) {
        case "alert":
          return "#F39C12";
        case "info":
          return "#2ECC71";
        default:
          return "";
      }
    }
  },
  methods: {
    async exec(func) {
      this.$set(func, "loading", true);

      try {
        await func.action(func.param);
      } finally {
        this.$store.dispatch("$_notifications/hideAlert");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  border: 3px solid black;
  border-radius: 15px;

  .v-btn {
    font-weight: 300;
  }

  h1 {
    font-size: 16px;
  }
}

.alert {
  border-color: #f39c12;

  .v-card__text {
    color: #f39c12 !important;

    .v-icon {
      color: #f39c12;
    }
  }
}

.info {
  border-color: #2ecc71;

  .v-card__text {
    color: #2ecc71 !important;

    .v-icon {
      color: #2ecc71;
    }
  }
}
</style>
